import { Component, Inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import {
  DynamicDialogConfig as OldDynamicDialogConfig,
  DynamicDialogRef as OldDynamicDialogRef,
} from "primeng-v17/dynamicdialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Message } from "primeng/message";
import { environment } from "../../../../environments/environment";
import { NewUiInputtextComponent } from "../../../shared/form/inputtext/new-ui-inputtext.component";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { ITranslationProposal } from "../translationProposal.model";

@Component({
  selector: "new-ui-translation-proposal-gathering",
  templateUrl: "./new-ui-translationProposalGathering.component.html",
  imports: [TranslateDirective, FormsModule, NewUiInputtextComponent, NewUiButton, Message],
})
export class NewUiTranslationProposalGatheringComponent {
  textToCorrect = null;
  textCorrected = null;
  reasonForCorrection = null;
  comment = null;

  constructor(
    @Inject(environment.newUI ? DynamicDialogConfig : OldDynamicDialogConfig)
    private readonly config: OldDynamicDialogConfig | DynamicDialogConfig,
    @Inject(environment.newUI ? DynamicDialogRef : OldDynamicDialogRef)
    private readonly dialog: OldDynamicDialogRef | DynamicDialogRef
  ) {
    this.textToCorrect = this.config.data.textToTranslate;
    this.textCorrected = this.textToCorrect;
  }

  cancel(_event: MouseEvent): void {
    this.dialog.close(null);
  }

  submit(_event: MouseEvent): void {
    this.dialog.close({
      textToCorrect: this.textToCorrect,
      translationProposal: this.textCorrected,
      reasonForCorrection: this.reasonForCorrection,
    } as ITranslationProposal);
  }
}
